import axiosInstance from "../utils/axiosConfig"

/**
    * @function demographicsListService
    * @param ({ type, typeId })
    * @description call API to get the country/city/state list
*/
export const demographicsListService = async ({ type, typeId }) => {
    try {
        const result = await axiosInstance.get(`users/country/StateCity?type=${type}&typeId=${typeId}`);
        return result;
    } catch (error) {
        console.error('[DemographicsService] API Error:', {
            message: error.message,
            response: error.response?.data,
            status: error.response?.status
        });
        throw error;
    }
}
